import React from 'react';

/**
 * Error Boundary for all Community UI.
 * If any community component crashes, this catches the error and
 * silently hides the community section. The planner is never affected.
 */
class CommunityErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[Community] Error caught by boundary:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Silently hide community — planner keeps working
      return null;
    }
    return this.props.children;
  }
}

export default CommunityErrorBoundary;
